import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as u, S as g } from "./icons.types-0722eef5.js";
function p({ title: s, titleId: c, size: o, width: i, height: t, extended: h = !1, ...a }) {
  const r = h ? u : g, n = o ? r[o] : i || r[h ? "s" : "l"], e = o ? r[o] : t || r[h ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: n,
      height: e,
      "aria-labelledby": c,
      ...a,
      children: [
        s ? /* @__PURE__ */ l("title", { id: c, children: s }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Troubleshoot_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M38.464 47.009c-2.102-4.245-2.415-9.038-.883-13.497a17.468 17.468 0 0 1 4.9-7.353c-4.253-7.174-8.252-13.883-10.35-17.323-.703-1.15-2.364-1.138-3.066.01L3.573 51.465C2.927 52.594 3.744 54 5.045 54h39.65a17.683 17.683 0 0 1-6.23-6.991ZM27.9 17.999h5.4v1.8c0 3.42-.9 15.48-1.26 19.8h-2.88c-.54-4.32-1.26-16.38-1.26-19.8V18Zm2.639 32.4a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Zm39.258 8.535-5.68-7.323c-.58-.748-1.626-.89-2.404-.38 2.686-1.645 4.819-4.154 5.886-7.264 2.49-7.245-1.427-15.181-8.734-17.692a14.057 14.057 0 0 0-4.586-.77c-5.958 0-11.254 3.761-13.178 9.357-2.49 7.245 1.428 15.181 8.734 17.692 1.485.512 3.027.77 4.586.77 2.567 0 4.99-.733 7.094-1.975l-.282.217a1.8 1.8 0 0 0-.32 2.526l7.611 9.812a.45.45 0 0 0 .632.079 3.601 3.601 0 0 0 .64-5.051v.002ZM46.49 32.659a10.368 10.368 0 0 1 7.79-3.555c1.132 0 2.284.186 3.416.574 5.436 1.869 8.345 7.742 6.498 13.119-1.184 3.445-4.042 5.823-7.367 6.613L46.49 32.66Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Troubleshoot_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as Troubleshoot
};
